import { call, put, takeEvery, takeLatest, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import axios from 'axios';
import { getUser, loginToken } from './actions';
import { showAndRemove } from '../../redux/toasts/actions';
import { getAgentsCharacters } from '../../redux/agents/actions';

function* showChangePasswordToast() {
  yield put(showAndRemove('Vous pouvez modifier votre mot de passe', {
    delay: 10000,
    actionLabel: 'Changer',
    actionRedirect: '/settings',
  }));
}

export function* onMagicLinkSuccess() {
  yield call(apiCall, getUser({ 
    redirect: '/agents',
    event: 'login',
    origin: 'magic_link' }));
  yield call(showChangePasswordToast);
}

export function* onEmailValidationSuccess() {
  yield call(apiCall, getUser({ 
    redirect: '/agents',
    event: 'login',
    origin: 'validation_email' }));
  yield call(showChangePasswordToast);
}

export function* onGoogleAuthSuccess() {
  yield call(apiCall, getUser({ 
    redirect: '/agents',
    event: 'login',
    origin: 'google_auth' }));
}

export function* onLinkedinAuthSuccess() {
  yield call(apiCall, getUser({
    redirect: '/agents',
    event: 'login',
    origin: 'linkedin_auth' }));
}

export function* onLoginSuccess() {
  yield call(apiCall, getUser({ 
      redirect: '/agents',
      event: 'login',
      origin: 'login',
    }));
}

export function* onRegisterSuccess() {
  yield call(apiCall, getUser({ 
      redirect: '/agents',
      event: 'sign_up',
      origin: 'sign_up',
    }));
}

export function* onLoginTokenAuto({ payload }) {
  yield call(apiCall, loginToken(payload.token));
  yield call(apiCall, getUser({ redirect: '/', type: 'login', origin: 'login_token'}));
}

export function* onGetUserSuccess({ payload, initial }) {
  // console.log('postMessage SSAGA', action.payload.sessionToken);
  // window.postMessage(
  //   { type: 'SESSION_TOKEN', token: action.payload.sessionToken, source: 'ozly' },
  //   '*',
  // );

  if (initial?.body?.origin && initial?.body?.event) {
    const event = initial.body.event;

    if (payload?.isSignUp) { // do not forget to return this from the backend for google / linkedin
        event = 'sign_up';
    }
  }

  yield put(getAgentsCharacters());
   
  if (payload.user && initial.body.redirect) {
    console.log(1);
    yield put(push(initial.body.redirect));
  } else if (payload.user && window.location?.pathname.search('/login') !== -1 && payload?.user?.type !== 'guest') {
    console.log(2);
    yield put(push('/agents'));
  }
}

function* callApi(url, method, body, query, langServe) {
  try {
    const user_id = yield select(state => state.global.user?._id);
    const options = {
      method,
      data: body,
      params: query,
      headers: {
        'Content-Type': 'application/json',
        ...langServe ? {
          'session-id': user_id,
        } : {},
        originfrom: window.location.pathname
      },
      withCredentials: true,
    };

    const response = yield call(axios, url, options);
    return response.data;
  } catch (err) {
    throw err;
  }
}

function* apiCall(action) {
  const { type, baseUrl, requestType, body, query, langServe, ...rest } = action;
  const [REQUEST, SUCCESS, FAILURE] = type;

  try {

    yield put({ type: REQUEST, payload: { body, query }, ...rest });

    const BASE_URL = langServe ? `${process.env.LANG_SERVE_URL}${baseUrl}` : `${process.env.API_URL}${baseUrl}`;
  
    const response = yield callApi(
      BASE_URL,
      requestType,
      body,
      query,
      langServe,
    );

    yield put({ type: SUCCESS, payload: response, initial: {
      body,
      // query
    }, ...rest });
  } catch (error) {
    yield put({
      type: FAILURE,
      error: {
        status: error?.response?.status,
        statusText: error?.response?.statusText,
        message: error?.message,
        data: error?.response?.data
      },
      ...rest
    });
  }
}



export default function* githubData() {
  yield takeLatest('LOGIN_TOKEN_AUTO', onLoginTokenAuto);

  yield takeLatest('LOGIN_MAGIC_LINK_SUCCESS', onMagicLinkSuccess);
  yield takeLatest('EMAIL_VALIDATION_SUCCESS', onEmailValidationSuccess);
  yield takeLatest('LOGIN_SUCCESS', onLoginSuccess);

  yield takeLatest('REGISTER_SUCCESS', onRegisterSuccess);

  yield takeLatest('AUTHENTICATE_GOOGLE_SUCCESS', onLoginSuccess);
  yield takeLatest('AUTHENTICATE_LINKEDIN_SUCCESS', onLoginSuccess);
  
  yield takeEvery('GET_USER_SUCCESS', onGetUserSuccess);

  yield takeLatest(action => {
    return (Array.isArray(action.type) && !action?.takeEvery) ;
  }, apiCall);

  yield takeEvery(action => {
    return (action?.takeEvery && Array.isArray(action.type)) ;
  }, apiCall);

  yield call(apiCall, getUser({
    event: 'login',
    origin: 'login_cookie'
  }));
}